module.exports = "/images/drought@3x.png?f2ee9f3fb78d398e6de0b483376a369d";